module.exports = __webpack_public_path__ + "static/egg-race-to-the-death-start-screen-452ad87c2f4613b057b2864f59bbc5c6.png";